import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { usePlatform } from '../../../../features/providers/platform-provider';
import Div from '../../div';
import HdTag from '../../hd-tag';
import { Tablet } from '../../Media';
import Typography from '../../typography';
const PageLayoutTitle = ({ title, status, styles, }) => {
    const theme = useTheme();
    const { app } = usePlatform();
    return (_jsxs(Div, { flex: "row", align: "center", gap: 24, tablet: {
            flex: 'column-reverse',
            align: 'flex-start',
            gap: 14,
        }, style: Object.assign({ maxWidth: '100%' }, styles === null || styles === void 0 ? void 0 : styles.title), fitContent: true, children: [_jsx(Typography.Title, { level: 1, elementTheme: app === 'admin' ? 'h6' : 'h5', noMargin: true, color: theme.colors.primary, fitContent: true, style: Object.assign({ maxWidth: '100%' }, styles === null || styles === void 0 ? void 0 : styles.titleTypography), children: title }), status && (_jsxs(_Fragment, { children: [_jsx(Tablet, { direction: "up", children: _jsx("div", { style: {
                                height: 'auto',
                                alignSelf: 'stretch',
                                borderLeft: `1px solid ${theme.colors.primary}`,
                            } }) }), _jsx(HdTag, Object.assign({}, status))] }))] }));
};
export default PageLayoutTitle;
